import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {CommonFunctions} from '../../helpers/core/common.functions';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {

  @Input('paginationData') public data;
  @Input('dataFilter') public filter;
  @Output() public childEvent = new EventEmitter();

  public childPagination;

  constructor(private c_f: CommonFunctions) { }

  ngOnInit() {
    this.childPagination = this.c_f.get_pagination(this.data.current_page, this.data.last_page);
  }

  ngOnChanges()
  {
    this.updatePagination();
  }

  loadData(event){
    this.childEvent.emit(event);
  }

  updatePagination(){
    this.childPagination = this.c_f.get_pagination(this.data.current_page, this.data.last_page);
  }
}
